import { Menu } from 'antd';
import { getInsightsCopy } from './constants';
import { Insights } from '../../services/types';
import { MessagingEffectivelySection } from './messageEffectivelySection';
import { MeetingStrategicallySection } from './meetStrategicallySection';
import { FollowUpSection } from './folllowUpSection';
import styles from './body.module.less';
import { MenuInfo } from 'rc-menu/lib/interface';
import TakeAwaysCard from './takeAwaysCard';
import { MessageOutlined, ScheduleOutlined, NotificationOutlined } from '@ant-design/icons';

type InsightsProps = {
	insights: Insights;
};

/**
 * Body content for the personalized insights page
 * @param param0
 * @returns
 */
export default function InsightsBody({ insights }: InsightsProps) {
	const { messaging, meeting, following } = getInsightsCopy(insights);
	function onClick(i: MenuInfo) {
		const element = document.getElementById(i.key);
		if (element) {
			element.scrollIntoView({ behavior: 'smooth' });
		}
	}
	return (
		<div className={styles.bodyWrapper}>
			<div className={styles.bodyContainer}>
				<Menu
					onClick={onClick}
					className={styles.menu}
					mode="inline"
					defaultSelectedKeys={['#message-effectively']}
					items={[
						{
							key: '#message-effectively',
							label: 'Message Effectively',
							icon: <MessageOutlined />,
						},
						{
							key: '#meet-strategically',
							label: 'Meet Strategically',
							icon: <ScheduleOutlined />,
						},
						{
							key: '#follow-up-for-success',
							label: 'Follow Up for Success',
							icon: <NotificationOutlined />,
						},
					]}
				/>
				<div className={styles.sectionWrapper}>
					<MessagingEffectivelySection
						data={messaging}
						communicationStyle={insights.commStyle}
					/>
					<MeetingStrategicallySection
						data={meeting}
						communicationStyle={insights.commStyle}
					/>
					<FollowUpSection data={following} communicationStyle={insights.commStyle} />
					<div className={styles.mobileTakeAwaysSection}>
						<TakeAwaysCard communicationStyle={insights.commStyle} />
					</div>
				</div>
				<div className={styles.takeAwaysSection}>
					<TakeAwaysCard communicationStyle={insights.commStyle} />
				</div>
			</div>
		</div>
	);
}
